import { useEffect, useState } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import {
  uploadDocument,
  viewDocument,
  deleteDocument,
} from "../utiles/DocumentService";
import CustomLoader from "../static/CustomLoader";

const Annexture = ({ selectedId, mode, onHide, setRefresh, typeData }) => {
  const [mode1, setMode1] = useState(mode);
  const [selectedId1, setSelectedId1] = useState(selectedId);
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [path, setPath] = useState("");
  const [type, setType] = useState(0);
  const [filename, setFilename] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [filePreview, setFilePreview] = useState(null);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");
  const orgcode = localStorage.getItem("custCode") || "ptw";
  const envCode = localStorage.getItem("envcode") || "Prod";

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  const fetchEmployeeImage = async (empCode, logoName) => {
    setLoading(true);
    try {
      const folderPath = `${orgcode}/anexture_${empCode}`;
      const response = await viewDocument({
        projectCode: "Ptw",
        envCode,
        folderPath,
        fileName: logoName,
      });
      if (response.cd === 1) {
        return "";
      }
      if (response) {
        const mimeType = logoName.toLowerCase().endsWith(".pdf")
          ? "application/pdf"
          : "image/jpeg";
        return `data:${mimeType};base64,${response}`;
      }
      return "";
    } catch (err) {
      console.error("Failed to fetch image:", err);
      return "";
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode1 === "U") {
      const fetchAnnextureData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `${apiUrl}annexture/id/${selectedId1}`,
            { headers },
          );
          const data = response.data;
          if (data.cd === 1) {
            toast.info(data.description);
          } else {
            setId(data.id);
            setCode(data.code);
            setType(data.type);
            setFilename(data.filename);
            setPath(data.path);
            const fileUrl = await fetchEmployeeImage(data.code, data.filename);
            setFilePreview(fileUrl);
          }
        } catch (error) {
          toast.error("Failed to fetch details.");
        } finally {
          setLoading(false);
        }
      };
      fetchAnnextureData();
    }
  }, [mode]);

  function clearFields() {
    setId("");
    setCode("");
    setType(0);
    setFilename("");
    setPath("");
    setFilePreview(null);
    setErrors({});
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    let effectiveCode = code;
    if (mode1 === "A" && !code) {
      const addResult = await handleAdd();
      if (!addResult) {
        toast.warning("Please try again.");
        setLoading(false);
        return;
      }
      effectiveCode = addResult.code;
      setMode1("U");
    }

    const folderPath = `${orgcode}/anexture_${effectiveCode}`;
    const maxRetries = 3;
    const formData = new FormData();
    formData.append("file", file);

    if (path) {
      const confirmReplace = window.confirm(
        `A file (${filename}) already exists. If you proceed, it will be deleted and replaced with the new one.`,
      );
      if (!confirmReplace) {
        return;
      }

      try {
        const response = await deleteDocument({
          projectCode: "Ptw",
          envCode: envCode,
          folderPath,
          fileName: filename,
        });
        if (response && response.cd === 1) {
          toast.error(response.description);
        }
      } catch (err) {
        console.warn("Failed to delete previous file", err);
        toast.warning("Could not delete previous file.");
      }
    }

    setLoading(true);

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const uploadRes = await uploadDocument({
          file,
          projectCode: "Ptw",
          envCode,
          folderPath,
        });

        if (uploadRes?.cd === 1) {
          toast.error(uploadRes.description);
          setLoading(false);
          return;
        }

        toast.success("File Upload. Proceed to save data!");
        setFilename(file.name);
        setPath(uploadRes);

        const fileUrl = await fetchEmployeeImage(effectiveCode, file.name);

        setFilePreview(fileUrl);
        break;
      } catch (error) {
        console.warn(`Attempt ${attempt} failed`, error);
        if (attempt === maxRetries) {
          toast.error("Upload failed after multiple attempts.");
        } else {
          await new Promise((resolve) => setTimeout(resolve, 2000 * attempt));
        }
      }
    }

    setLoading(false);
  };

  const validateFields = () => {
    let errors = {};
    if (!filename) {
      errors.filename = "File is required...";
    }
    return errors;
  };

  const handleAdd = async () => {
    const data = {
      id: 0,
      code: 0,
      type,
      filename: filename ? filename : "",
      path: path ? path : "",
    };

    try {
      const response = await axios.post(
        `${apiUrl}annexture`,
        { data },
        { headers },
      );

      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
        setShowSucessModal(true);
      } else {
        setId(response.data.id);
        setCode(response.data.code);
        setType(response.data.type);
        setSelectedId1(response.data.id);
        return response.data;
      }
    } catch (error) {
      toast.error("Something went wrong while adding data.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      const response = await axios.put(
        `${apiUrl}annexture/${selectedId1}`,
        {
          id,
          code,
          type,
          filename,
          path,
        },
        { headers },
      );

      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
      } else {
        setSucessMessage(response.data.description);
        setTitle("✔️ Success");
      }

      setShowSucessModal(true);
    } catch (error) {
      toast.error("Something went wrong while updating data.");
    } finally {
      setLoading(false);
    }
  };

  const handlesubmit = async () => {
    setLoading(true);

    const fieldErrors = validateFields();

    setErrors(fieldErrors);

    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct all required input fields.");
      setLoading(false);
      return;
    }

    if (mode1 === "A") {
      await handleAdd();
    } else {
      await handleUpdate();
    }
  };

  return (
    <>
      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />

      <div className="popupmodal-maindiv">
        <div className="form-group">
          <label>Attach File</label>

          <input
            type="file"
            className="form-control"
            onChange={handleFileChange}
            accept="image/*,application/pdf"
          />

          {filename && (
            <Box
              sx={{
                mt: 0.75,
                fontSize: 12,
                color: "#64748B",
              }}
            >
              Selected file:{" "}
              <Box
                component="span"
                sx={{
                  fontWeight: 600,
                  color: "#33485C",
                }}
              >
                {filename}
              </Box>
            </Box>
          )}

          {filePreview && (
            <Box
              sx={{
                mt: 1.5,
                p: 1,
                border: "1px solid #DCE4EC",
                borderRadius: "8px",
                backgroundColor: "#F8FAFC",
              }}
            >
              {filename?.toLowerCase().endsWith(".pdf") ? (
                <embed
                  src={filePreview}
                  type="application/pdf"
                  width="100%"
                  height="280px"
                  style={{
                    border: "1px solid #DCE4EC",
                    borderRadius: "6px",
                  }}
                />
              ) : (
                <Box
                  component="img"
                  src={filePreview}
                  alt="Preview"
                  sx={{
                    display: "block",
                    width: "100%",
                    maxWidth: 280,
                    maxHeight: 200,
                    objectFit: "contain",
                    mx: "auto",
                    borderRadius: "6px",
                  }}
                />
              )}
            </Box>
          )}

          {errors.filename && (
            <span className="error-message">{errors.filename}</span>
          )}
        </div>

        <div className="bottombtn">
          <button
            className="btn btn-success"
            disabled={loading}
            onClick={handlesubmit}
          >
            Save
          </button>

          <button className="btn btn-danger" onClick={clearFields}>
            Reset
          </button>
        </div>
      </div>

      {loading && <CustomLoader />}
    </>
  );
};

export default Annexture;
